<template>
  <div class="lottery-overlay">
    <div class="lottery-modal">
      <!-- 背景图 -->
      <img :src="bgImage" alt="背景" class="bg-img">

      <!-- 关闭按钮 -->
      <div class="close-btn" @click="handleClose">
        <img src="../assets/btn/close.png" alt="关闭">
      </div>

      <!-- 分享按钮 -->
<!--      //1 是邀请-->
      <div class="share-btn"  @click="handleShare">
        <img src="../assets/btn/share.png" alt="关闭">
      </div>

      <div class="lotteryBody" v-if="prizeLevel === null || prizeLevel > 0">
        <!-- 加载中 -->
        <div class="loading-area" v-if="prizeLevel === null">
          <span class="loading-text">加载中...</span>
        </div>

        <!-- 中奖标题图片 -->
        <div class="title-area" v-else-if="prizeLevel > 0 && !claimed">
          <img :src="titleImage" alt="标题" class="title-img">
        </div>

        <!-- 奖品图片 -->
        <div class="prize-img-area" v-if="prizeLevel > 0 && !claimed">
          <img :src="prizeImage" alt="奖品" class="prize-img">
        </div>

        <!-- 兑换码区域 -->
        <div class="code-section" v-if="prizeLevel > 0 && !claimed">
          <span class="code-txt">兑换码</span>
          <span class="code-text">{{ redeemCode }}</span>
          <button class="copy-btn" @click="copyCode">
            {{ copyText }}
          </button>
        </div>

        <!-- 领取按钮 -->
<!--        <div class="claim-section" v-if="prizeLevel > 0 && !claimed">-->
<!--          <button class="claim-btn" @click="claimPrize">-->
<!--            立即领取-->
<!--          </button>-->
<!--        </div>-->
<!--        console.log(res.data.shareCount)-->
        <!-- 已中奖提示 -->
        <div class="claimed-info" v-if="prizeLevel > 0 && claimed">

          <p class="claimed-text" v-if="tipsType==-1">您的抽奖机会已使用完毕</p>
          <p class="claimed-text" v-if="prizeName">抽奖结果为：<span class="result-highlight">{{ prizeName }}</span></p>
<!--     0 提示分享再送一次机会  1提示分享没有机会-->

          <div v-if="tipsType==-1">
            <p class="claimed-text" >点击【我的奖品】即可查看中奖结果</p>
            <p class="claimed-result">感谢您的参与</p>
            <p class="claimed-result result-highlight">分享好友邀 TA 来寻宝！</p>
          </div>

          <div v-if="tipsType>0">
            <p class="claimed-text" style="margin-bottom: 2%">点击【我的奖品】即可查看中奖结果</p>
            <p class="claimed-text claimed-result">分享活动</p>
            <p class="claimed-text result-highlight claimed-result"> 再送1次抽奖机会哦~</p>
          </div>

          <div v-if="tipsType==0">
            <p class="claimed-text" style="margin-bottom: 2%">点击【我的奖品】即可查看中奖结果</p>
            <p class="claimed-text claimed-result">感谢您的参与</p>
            <p class="claimed-text  claimed-result result-highlight">分享好友邀 TA来寻宝!</p>
          </div>
          <div v-if="tipsType==2">
            <p class="claimed-text" style="margin-bottom: 2%">点击【我的奖品】即可查看中奖结果</p>
            <p class="claimed-text claimed-result">感谢您的参与</p>
            <p class="claimed-text  claimed-result result-highlight">分享好友邀 TA来寻宝!</p>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {reqDraw } from '@/api';
export default {
  name: 'Lottery',

  props: {
    //0 提示分享再送一次机会  1提示分享没有机会
    LTipsType: {
      type: Object,
      default:""
    }
  },
  data() {
    return {
      prizeLevel: null,
      redeemCode: '',
      copyText: '复制',
      claimed: false, // 是否已领取
      tipsType:"",
      tipsType1:""
    }
  },
  computed: {
    bgImage() {
      if (this.prizeLevel === null) return require('../assets/draw/1.png')
      if (this.prizeLevel === 0) return require('../assets/draw/0.png')
      if (this.prizeLevel > 0 && this.claimed) return require('../assets/draw/2.png')
      return require('../assets/draw/1.png')
    },
    titleImage() {
      if (this.prizeLevel === 1) return require('../assets/draw/t1.png')
      if (this.prizeLevel === 2) return require('../assets/draw/t2.png')
      if (this.prizeLevel === 3) return require('../assets/draw/t3.png')
      return ''
    },
    prizeImage() {
      if (this.prizeLevel === 1) return require('../assets/myprize/1.png')
      if (this.prizeLevel === 2) return require('../assets/myprize/2.png')
      if (this.prizeLevel === 3) return require('../assets/myprize/3.png')
      return ''
    },
    prizeName() {
      if (this.prizeLevel === 1) return '1000元微信立减金'
      if (this.prizeLevel === 2) return '18.8元微信立减金'
      if (this.prizeLevel === 3) return '1.08元微信立减金'
      if (this.prizeLevel === 4) return ''
      return ''
    }
  },
  mounted() {
    this.fetchLotteryResult()


  },
  methods: {
    async fetchLotteryResult() {
      if(this.LTipsType.prizeId>0){
        this.prizeLevel =this.LTipsType.prizeId;
        this.redeemCode = this.LTipsType.code;
        this.claimed = true;
        this.tipsType = this.LTipsType.type;
      }else{
        try {
          reqDraw().then(res=>{
            // if(res.data.state ==1 && res.data.prizeId>0){
            //   //中奖
            //   //state==1  正常抽奖
            //   //state==2  没有抽奖次数
            //   //state==3  重复抽奖
            // }
            if(res.data.state==2){
              this.prizeLevel = 4;
              this.claimed = true
              this.redeemCode =false;
              // this.tipsType = -1
              return;
            }
            this.prizeLevel =  res.data.prizeId;
            this.redeemCode = res.data.code;
            //isDraw
          })


        } catch (error) {
          console.error('抽奖请求失败:', error)
          this.prizeLevel = 0
          this.redeemCode =false;
        }
      }

    },

    copyCode() {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(this.redeemCode).then(() => {
          this.copyText = '已复制'
          setTimeout(() => { this.copyText = '复制' }, 2000)
        }).catch(() => {
          this.fallbackCopy()
        })
      } else {
        this.fallbackCopy()
      }
    },
    fallbackCopy() {
      const textarea = document.createElement('textarea')
      textarea.value = this.redeemCode
      textarea.style.position = 'fixed'
      textarea.style.opacity = '0'
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand('copy')
      document.body.removeChild(textarea)
      this.copyText = '已复制'
      setTimeout(() => { this.copyText = '复制' }, 2000)
    },

    handleClose() {
      this.$emit('close')
    },
    handleShare() {
      this.$emit('userShare')

    },

    claimPrize() {
      // 标记为已领取
      this.claimed = true
    }
  }
}
</script>

<style scoped>
.lottery-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
}

.lottery-modal {
  position: relative;
  width: 90%;
  border-radius: 16px;
  margin-top: -13%;
}

/* 背景图 */
.bg-img {
  width: 100%;
  height: auto;
  display: block;
  pointer-events: painted;
}

/* 关闭按钮 */
.close-btn {
  position: absolute;
  bottom: -19%;
  width: 100%;
  z-index: 10;
  text-align: center;
  cursor: none;
  z-index: 2;
}

.close-btn img {
  width: 12%;
}

/* 分享按钮 */
.share-btn {
  position: absolute;
  bottom:-10%;
  width: 100%;
  z-index: 10;
  text-align: center;
  cursor: none;
}

.share-btn img {
  width: 70%;
}



/* 中奖标题图片 */
.title-area {
  width: 100%;
  text-align: center;
  margin-top: 13%;
}

.title-img {
  width: 50%;
  height: auto;
}

/* 加载中 */
.loading-area {
  position: absolute;
  top: 40%;
  left: 0;
  width: 100%;
  text-align: center;
}

.loading-text {
  color: #999;
  font-size: 1rem;
}

.lotteryBody{width: 100%;height: 100%; position: absolute; top:0; pointer-events: none;}
/* 奖品图片 */
.prize-img-area {
  box-sizing: border-box;
  text-align: center;
}

.prize-img {
  width: 51%;
}

/* 兑换码区域 */
.code-section {
  position: absolute;
  bottom: 10%;
  left: 0;
  width: 105%;
  padding: 0 15%;
  box-sizing: border-box;
  pointer-events: painted;

}

.code-text {
  font-size: .7rem;
  font-weight: bold;
  color: #333;
  letter-spacing:1px;
  background: #f5f5f5;
  padding: 3px 12px;
  border-radius: 30px;
  margin-right: 10px;

}
.code-txt{
  color: #333;
  font-size: .7rem;
  margin-right: 2%;
}
.copy-btn {
  background: #c75421;
  color: #fff;
  border: none;
  padding: 3px 16px;
  border-radius: 30px;
  font-size: 0.85rem;
  cursor: pointer;
  white-space: nowrap;
}

.copy-btn:active {
  opacity: 0.8;
}

/* 领取按钮 */
.claim-section {
  position: absolute;
  bottom: 5%;
  left: 0;
  width: 100%;
  padding: 0 20%;
  box-sizing: border-box;
  text-align: center;
}

.claim-btn {
  background: linear-gradient(135deg, #ff6b35, #ff9a44);
  color: #fff;
  border: none;
  padding: 12px 32px;
  border-radius: 25px;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  box-shadow: 0 4px 15px rgba(255, 107, 53, 0.4);
}

.claim-btn:active {
  transform: scale(0.98);
  opacity: 0.9;
}

/* 已中奖提示 */
.claimed-info {
  position: absolute;
  top:12%;
  left: 0;
  width: 100%;
 text-align: center;

}

.claimed-text {
  font-size: .9rem;
  color: #381d06;
  line-height: 1.3;
}

.claimed-result {
  font-size: 1.2rem
}

.result-highlight {
  font-weight: bold;
  background-image: linear-gradient(to bottom, #2c1504, #e43e1d);
  -webkit-background-clip: text;
  color: transparent;
  /* 抗锯齿和增强文字边缘 */
  -webkit-font-smoothing: antialiased;
}

.claimed-hint {
  font-size: 0.9rem;
  color: #381d06;
  margin: 10px 0;
}

.claimed-thanks {
  font-size: 0.85rem;
  color: #bbb;
  margin: 15px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Lottery.vue